import { TCS_BASE_URL } from "../../CONSTANTS";
import { callPostAxios, callPutAxios,callGetAxios } from "../common/common";

export const getTcsAllRecords = (data) => {
    return callPostAxios(TCS_BASE_URL() + 'getAllRecords', data, 'tcsRecord');
};

export const addTcs = (data) => {
    return callPostAxios(TCS_BASE_URL(), data, 'addRecord');
};

export const editTcs = (uuid, data) => {
    return callPutAxios(TCS_BASE_URL() + uuid, data, 'editRecord', 'editRecord');
};

export const getKeyValueList = (data) =>{
    return callGetAxios (TCS_BASE_URL() + "getKeyValueList", 'getKeyValueList');
}